// Buyer
export const iam_user = [
  "Não consigo realizar a compra",
  "Informações sobre pagamento",
  "Reembolso ou cancelamento",
  "Alteração de dados de registo",
  "Fatura",
  "Problemas com o acesso ao conteúdo",
  "Dificuldades técnicas com a plataforma",
  "Dúvidas sobre a subscrição",
  "Outro assunto",
];

// Producer
export const iam_producer = [
  "Dificuldade em aceder à minha conta",
  "Alteração do e-mail da conta",
  "Revisão de produtos",
  "Revisão de contas bancárias",
  "Comissões e retirar valores",
  "Problemas com integrações (API, Webhooks, etc.)",
  "Configuração de produtos ou ofertas",
  "Dúvidas sobre faturação e impostos",
  "Outro assunto",
];

export const iam_affiliated = [
  "Dificuldade em aceder à minha conta",
  "Problemas com links de afiliado",
  "Comissões ou pagamentos",
  "Regras do programa de afiliados",
  "Outro assunto",
];

export const iam_partner = [
  "Dúvidas sobre integração técnica",
  "Acesso à conta ou gestão de utilizadores",
  "Regras de comissionamento e faturação",
  "Questões legais ou contratuais",
  "Outro assunto",
];
